export const appSettingsAuthenticationCredentialsIdUsages = "/app_settings/authentication_credentials/:id/usages";
